import React, { useEffect } from 'react';
import { Modal, Form, Switch } from 'antd';
import s from './s.module.less';
import commonS from 'styles/common.module.less';
import { ServerMeta } from 'types/common';

interface MedicationContentModalProps {
    visible: boolean;
    onCancel: () => void;
    onSave: (status: string) => void;
    condition?: ServerMeta;
    status?: string;
}

const TableContentModal: React.FC<MedicationContentModalProps> = ({
    visible,
    onCancel,
    onSave,
    condition,
    status,
}) => {
    const [form] = Form.useForm<{ status: boolean }>();

    // 当模态框打开或初始数据变化时，设置表单数据
    useEffect(() => {
        if (visible) {
            if (status) {
                form.setFieldsValue({
                    status: status === 'A',
                });
            } else {
                // 设置默认值
                const defaultValues = {
                    status: false,
                };
                form.setFieldsValue(defaultValues);
            }
        }
    }, [visible, status, form]);

    // 处理表单提交
    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            onSave(values.status ? 'A' : 'D');
        } catch (error) {
            console.error('表单验证失败:', error);
        }
    };

    // 处理取消
    const handleCancel = () => {
        form.resetFields();
        onCancel();
    };

    return (
        <Modal
            title={`Edit ${condition?.content}`}
            className={commonS.modalFixHeightWrap}
            open={visible}
            onCancel={handleCancel}
            okText="Save changes"
            onOk={handleSubmit}
            width={543}
            destroyOnClose
        >
            <Form
                form={form}
                layout="vertical"
                className={s.form}
            >
                {/* Title Field */}
                <Form.Item
                    label="Comparison table"
                    name="status"
                    valuePropName="checked"
                >
                    <Switch />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default TableContentModal;
